import Table from 'components/Table'
import DrupalContext from 'contexts/DrupalContext'
import ViewModeContext from 'contexts/ViewModeContext'
import useUrlParams from 'hooks/useUrlParams'
import useWindowDimensions from 'hooks/useWindowDimensions'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

function ResultsList({ documents = [], render }) {
  const { t } = useTranslation()
  const { urlParams } = useUrlParams()
  const drupal = useContext(DrupalContext)
  const searcher = drupal.niche || urlParams.searcher || 'global'
  const viewMode = getSearcherViewMode(searcher)

  const tableHeaders =
    {
      news: [t('Title'), t('Date'), t('News Area')],
      event: [t('Event'), t('Date'), t('Time'), t('Event Type')],
      education: [
        'Education Course / Programme',
        'Education Type',
        'Education Level',
        'Education Credits',
      ].map((n) => t(`table.education.${n}`)),
      person: [t('Name'), t('Employment')],
      organization: [t('Organisation'), t('Parent organisation'), t('E-mail')],
      research: [t('Title'), t('Category'), t('Date'), t('Research Area')],
      exchange_course: [t('Title'), t('Course Code'), t('Level'), t('Credits')],
      programme_page: [t('Title'), t('Type')],
      organization_page: [t('Title'), t('Type')],
    }[searcher] || []

  const displayMode = (context) => {
    let choice
    if (context.isTable) {
      return (
        <div className="u-mt-100">
          <Table modifierClasses={`table--${searcher}`} headers={tableHeaders}>
            {documents.map((doc) => render({ ...doc, tableHeaders }))}
          </Table>
        </div>
      )
    }

    if (context.isAccordionTable) {
      const Heading = [t('Title'), t('Type'), t('edu_code')]
      return (
        <section className="syllabuses__table">
          <header header className="syllabuses__table--heading">
            {Heading.map((name) => (
              <div className="syllabuses__table--col label u-text-uppercase">
                {name}
              </div>
            ))}
          </header>
          {documents.map((doc) => render(doc))}
        </section>
      )
    }

    return (
      <ul
        aria-label={t('Results')}
        className="wrapper u-mt-50 u-mt-100-medium-up"
      >
        {documents.map((doc) => render(doc))}
      </ul>
    )
  }
  return (
    <ViewModeContext.Provider key={searcher} value={viewMode}>
      <ViewModeContext.Consumer>
        {(context) => displayMode(context)}
      </ViewModeContext.Consumer>
    </ViewModeContext.Provider>
  )
}

export default ResultsList

const getSearcherViewMode = (searcher) => {
  const forceTeaserLowerBreakpoint = 900
  const windowDimensions = useWindowDimensions()

  return {
    modes: {
      global: 'teaser',
      news: 'table',
      event: 'table',
      education: 'table',
      syllabus: 'accordionTable',
      person: 'table',
      organization: 'table',
      research: 'table',
      exchange_course: 'table',
      programme_page: 'table',
      organization_page: 'table',
      local_page: 'accordion',
    },
    get activeMode() {
      return this.modes[searcher] || 'teaser'
    },
    get isTable() {
      return (
        this.activeMode === 'table' &&
        windowDimensions.width >= forceTeaserLowerBreakpoint
      )
    },
    get isAccordionTable() {
      return this.activeMode === 'accordionTable'
    },
    get isTeaser() {
      return (
        this.activeMode === 'teaser' ||
        windowDimensions.width < forceTeaserLowerBreakpoint
      )
    },
    get isAccordion() {
      return (
        this.activeMode === 'accordion' ||
        windowDimensions.width < forceTeaserLowerBreakpoint
      )
    },
  }
}
